<template>
    <div class="page">
      <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm" @keyup.enter.native="refreshList()" @submit.native.prevent>
          <!-- 搜索框-->
          <el-form-item prop="name">
                <el-input size="small" v-model="searchForm.name" placeholder="全称" clearable></el-input>
          </el-form-item>
          <!-- 搜索框-->
          <el-form-item prop="email">
                <el-input size="small" v-model="searchForm.email" placeholder="邮箱" clearable></el-input>
          </el-form-item>
          <el-form-item prop="phone">
                <el-input size="small" v-model="searchForm.phone" placeholder="联系电话" clearable></el-input>
          </el-form-item>
            <!-- 搜索框-->
          <el-form-item>
            <el-button type="primary" @click="refreshList()" size="small" icon="el-icon-search">查询</el-button>
            <el-button @click="resetSearch()" size="small" icon="el-icon-refresh-right">重置</el-button>
          </el-form-item>
      </el-form>

     <div class="bg-white top">
      <div><span>该模块时用于显示客户保存的UM套餐</span></div>
        <vxe-toolbar :refresh="{query: refreshList}" import export print custom>
          <template #buttons>
            <!-- <el-button v-if="hasPermission('cecunmusersetmeal:cecUnmUserSetMeal:add')" type="primary" size="small" icon="el-icon-plus" @click="add()">新建</el-button> -->
            <!-- <el-button v-if="hasPermission('cecunmusersetmeal:cecUnmUserSetMeal:edit')" type="warning" size="small" icon="el-icon-edit-outline" @click="edit()" :disabled="$refs.cecUnmUserSetMealTable && $refs.cecUnmUserSetMealTable.getCheckboxRecords().length !== 1" plain>修改</el-button> -->
            <el-button v-if="hasPermission('cecunmusersetmeal:cecUnmUserSetMeal:del')" type="danger"   size="small" icon="el-icon-delete" @click="del()" :disabled="$refs.cecUnmUserSetMealTable && $refs.cecUnmUserSetMealTable.getCheckboxRecords().length === 0" plain>删除</el-button>
          </template>
          <template #tools>
            <vxe-button
    		  type="default"
    		  title="下载导入模板"
    		  v-if="hasPermission('cecunmusersetmeal:cecUnmUserSetMeal:import')"
    		  class="el-icon-document m-r-12"
    		  @click="downloadTpl()"
    		  circle
            >
            </vxe-button>
          </template>
        </vxe-toolbar>
        <div style="height: calc(100% - 98px);">
        <vxe-table
            border="full"
            auto-resize
            resizable
            height="auto"
            :loading="loading"
            size="small"
            ref="cecUnmUserSetMealTable"
            show-header-overflow
            show-overflow
            highlight-hover-row
            :menu-config="{}"
            :print-config="{}"
            :import-config="{
            importMethod: importMethod,
                types: ['csv', 'xls', 'xlsx'],
                remote: true,
            }"
            :export-config="{
                remote: true,
                filename: `UM用户登记套餐表数据${moment(new Date()).format(
            		'YYYY-MM-DD'
                )}`,
                sheetName: 'UM用户登记套餐表数据',
                exportMethod: exportMethod,
                types: ['xlsx'],
                modes: ['current', 'selected', 'all'],
            }"
            @sort-change="sortChangeHandle"
            :sort-config="{remote:true}"
            :data="dataList"
            :checkbox-config="{}">
            <vxe-column type="checkbox"  width="40px"></vxe-column>
            <vxe-column type="seq" width="40"></vxe-column>
    <vxe-column
        field="name"
        sortable
        title="全名">
            <!-- <template slot-scope="scope">
              <el-link  type="primary" :underline="false" v-if="hasPermission('cecunmusersetmeal:cecUnmUserSetMeal:edit')" @click="edit(scope.row.id)">{{scope.row.name}}</el-link>
              <el-link  type="primary" :underline="false" v-else-if="hasPermission('cecunmusersetmeal:cecUnmUserSetMeal:view')"  @click="view(scope.row.id)">{{scope.row.name}}</el-link>
              <span v-else>{{scope.row.name}}</span>
            </template> -->
      </vxe-column>
    <vxe-column
        field="email"
        sortable
        width="200"
        title="邮箱">
      </vxe-column>
    <vxe-column
        field="phone"
        sortable
        width="200"
        title="联系电话">
      </vxe-column>
    <vxe-column
        field="message"
        sortable
        title="消息">
      </vxe-column>
      <vxe-column
        field="type"
        sortable
        title="用户设计来源">
        <template slot-scope="scope">
          <span v-if="scope.row.type">{{ scope.row.type == '1' ? '套餐' : '空间' }}</span>
          <span v-else>-</span>
        </template>
      </vxe-column>
      <vxe-column
        field="createDate"
        sortable
        width="150"
        title="创建时间">
      </vxe-column>
      <vxe-column
        fixed="right"
        align="center"
        width="200"
        title="操作">
        <template  slot-scope="scope">
          <!-- <el-button v-if="hasPermission('cecunmusersetmeal:cecUnmUserSetMeal:view')" type="text" icon="el-icon-view" size="small" @click="view(scope.row.id)">查看</el-button>
          <el-button v-if="hasPermission('cecunmusersetmeal:cecUnmUserSetMeal:edit')" type="text" icon="el-icon-edit" size="small" @click="edit(scope.row.id)">修改</el-button>
          <el-button v-if="hasPermission('cecunmusersetmeal:cecUnmUserSetMeal:del')" type="text"  icon="el-icon-delete" size="small" @click="del(scope.row.id)">删除</el-button> -->
          <el-button v-if="hasPermission('cecunmusersetmeal:cecUnmUserSetMeal:view')" type="text" size="small" @click="gotoSetsMeal(scope.row)">查看用户套餐</el-button>
        </template>
      </vxe-column>
    </vxe-table>
    <vxe-pager
      background
      size="small"
      :current-page="tablePage.currentPage"
      :page-size="tablePage.pageSize"
      :total="tablePage.total"
      :page-sizes="[10, 20, 100, 1000, {label: '全量数据', value: 1000000}]"
      :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
      @page-change="currentChangeHandle">
    </vxe-pager>
    </div>
    </div>
        <!-- 弹窗, 新增 / 修改 -->
    <CecUnmUserSetMealForm  ref="cecUnmUserSetMealForm" @refreshDataList="refreshList"></CecUnmUserSetMealForm>
  </div>
</template>

<script>
  import CecUnmUserSetMealForm from './CecUnmUserSetMealForm'
  import cecUnmUserSetMealService from '@/api/cecunmusersetmeal/cecUnmUserSetMealService'
  export default {
    data () {
      return {
        searchForm: {
          name: '',
          email: '',
          phone: ''
        },
        dataList: [],
        tablePage: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
          orders: [{ column: 'create_date', asc: false }]
        },
        loading: false
      }
    },
    components: {
      CecUnmUserSetMealForm
    },
    activated () {
      this.refreshList()
    },
    methods: {
      gotoSetsMeal (data) {
        this.$router.push({path: '/cecunmusersetmeal/CecUnmUserSetsMealProject', query: {id: data.id}})
      },
      // 获取数据列表
      refreshList () {
        this.loading = true
        cecUnmUserSetMealService.list({
          'current': this.tablePage.currentPage,
          'size': this.tablePage.pageSize,
          'orders': this.tablePage.orders,
          ...this.searchForm
        }).then(({data}) => {
          this.dataList = data.records
          this.tablePage.total = data.total
          this.loading = false
        })
      },
      // 当前页
      currentChangeHandle ({ currentPage, pageSize }) {
        this.tablePage.currentPage = currentPage
        this.tablePage.pageSize = pageSize
        this.refreshList()
      },
      // 排序
      sortChangeHandle (obj) {
        this.tablePage.orders = []
        if (obj.order != null) {
          this.tablePage.orders = [{ column: obj.column.sortBy || this.$utils.toLine(obj.property), asc: obj.order === 'asc' }]
        } else {
          this.tablePage.orders = [{ column: 'create_date', asc: false }]
        }
        this.refreshList()
      },
      // 新增
      add () {
        this.$refs.cecUnmUserSetMealForm.init('add', '')
      },
      // 修改
      edit (id) {
        id = id || this.$refs.cecUnmUserSetMealTable.getCheckboxRecords().map(item => {
          return item.id
        })[0]
        this.$refs.cecUnmUserSetMealForm.init('edit', id)
      },
      // 查看
      view (id) {
        this.$refs.cecUnmUserSetMealForm.init('view', id)
      },
      // 删除
      del (id) {
        let ids = id || this.$refs.cecUnmUserSetMealTable.getCheckboxRecords().map(item => {
          return item.id
        }).join(',')
        this.$confirm(`确定删除所选项吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          cecUnmUserSetMealService.delete(ids).then(({data}) => {
            this.$message.success(data)
            this.refreshList()
            this.loading = false
          })
        })
      },
      // 下载模板
      downloadTpl () {
        this.loading = true
        cecUnmUserSetMealService.exportTemplate().then(({data}) => {
    // 将二进制流文件写入excel表，以下为重要步骤
          this.$utils.downloadExcel(data, '请假表单导入模板')
          this.loading = false
        }).catch(function (err) {
          this.loading = false
          if (err.response) {
            console.log(err.response)
          }
        })
      },
      // 自定义服务端导入
      importMethod ({ file }) {
      // 处理表单
        const formBody = new FormData()
        formBody.append('file', file)
        this.loading = true
        cecUnmUserSetMealService.importExcel(formBody).then(({data}) => {
          this.$message.success({
            dangerouslyUseHTMLString: true,
            message: data
          })
          this.refreshList()
        })
      },
      // 自定义服务端导出
      exportMethod ({ options }) {
      // 传给服务端的参数
        const params = {
          current: this.tablePage.currentPage,
          size: this.tablePage.pageSize,
          orders: this.tablePage.orders,
          ...this.searchForm,
          filename: options.filename,
          sheetName: options.sheetName,
          isHeader: options.isHeader,
          original: options.original,
          mode: options.mode,
          selectIds: options.mode === 'selected' ? options.data.map((item) => item.id) : [],
          exportFields: options.columns.map((column) => column.property && column.property.split('.')[0])
        }
        this.loading = true
        return cecUnmUserSetMealService.exportExcel(params).then(({data}) => {
      // 将二进制流文件写入excel表，以下为重要步骤
          this.$utils.downloadExcel(data, options.filename)
          this.loading = false
        }).catch(function (err) {
          if (err.response) {
            console.log(err.response)
          }
        })
      },
      resetSearch () {
        this.$refs.searchForm.resetFields()
        this.refreshList()
      }
    }
  }
</script>

